export default __webpack_public_path__ + "static/media/10.b2c02948.JPG";